import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getUrl } from '@ov-suite/helpers-angular/lib/get-url.helper';
import { firstValueFrom } from 'rxjs';

export interface ManualJournalRequest {
  action: 'Manual';
  amount: number;
  description: string;
  responsibleUserId: number;
  productSkuId: number;
  fromLocationId?: number;
  fromHeldByUserId?: number;
  toLocationId?: number;
  toHeldByUserId?: number;
}

@Injectable({
  providedIn: 'root',
})
export class JournalEventsService {
  private readonly baseUrl = `${getUrl('api')}/api/inventory/inventory-journal`;

  constructor(private readonly http: HttpClient) {}

  createJournal(request: ManualJournalRequest) {
    return firstValueFrom(this.http.post(`${this.baseUrl}/create`, request));
  }

  removeJournal(request: ManualJournalRequest) {
    return firstValueFrom(this.http.post(`${this.baseUrl}/remove`, request));
  }
}
